module.exports = __webpack_public_path__ + "img/SqualoSport-interno3.2204801c.jpeg";